module.exports = "<div class=\"container-fluid\" id=\"{{sessionObject.currentClientCode}}\">\r\n  <div class=\"row justify-content-between\">\r\n    <app-left-nav></app-left-nav>\r\n\r\n    <main class=\"col-sm-9 offset-sm-2 col-md-10 pt-3 \">\r\n      <!-- <angular-loader></angular-loader> -->\r\n      <router-outlet></router-outlet>\r\n    </main>\r\n\r\n\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pages.component.html
// module id = ./src/app/pages/pages.component.html
// module chunks = main